import { Power2, TweenMax } from 'gsap';
import $ from 'jquery';
import PassengerRoomClass from './PassengerRoomClass';
import PickModalClass from '../common/PickModalClass';
import Util from '../../libs/util/Util';

/**
 * 宿泊者のモーダル
 */
export default class PassengerModalClass extends PickModalClass {
  constructor(_id, _parent) {
    super(_id);
    this.name = 'PassengerModalClass';

    this.parent = _parent;

    this.rooms = [];
    this.roomMax = 8;

    this.onClickAddRoomListener = this.onClickAddRoom.bind(this);

    this.isAddBtnFlag = true;

    this.prevErrorPosition = null;

    this.prevRoomsData = [
      { adult: 2, child: 0, ageList: [] },
    ];
  }

  onCreate() {
    super.onCreate();

    this.HTML_TEMPLATE_ROOM = $('.room_template', this.modal).html();

    this.roomInsertTarget = $('.wrap', this.modal);

    this.btnAddRoom = $('.add_room_button', this.modal);


    this.error = $('.passengers_error', this.modal);
    this.error.css({ display: 'none' });
    TweenMax.set(this.error, { y: '5%' });

    $('a', this.btnAddRoom).on('click', this.onClickAddRoomListener);

    this.resetRoom();
    this.setPassengerButtonText();
  }

  onPositiveBefore() {
    // console.log(this.name,"onPositiveBefore");
    this.prevRoomsData = [];
    for (let k in this.rooms) {
      this.rooms[k].onPositive();
      this.prevRoomsData.push(this.rooms[k].getPassengers());
    }
    this.setPassengerButtonText();
  }

  onNegative() {
    // console.log(this.name,"onNegative");
    this.resetRoom();
  }

  onSetData(_data) {
    this.prevRoomsData = _data;
    this.resetRoom();
    this.setPassengerButtonText();
  }

  onCheckSubmitError() {
    let data = [];
    for (let i = 0; i < this.rooms.length; i++) {
      const re = this.rooms[i].onCheckSubmitError();
      if (re.isError) {
        re.msg = '部屋' + (i + 1) + 'の' + re.msg;
        return re;
      }
      data.push(this.rooms[i].getPassengers());
    }

    let total = { adult: 0, child: 0, ageList: [] };
    for (let k in data) {
      total.adult += data[k].adult;
      total.child += data[k].child;
      total.ageList = total.ageList.concat(data[k].ageList);
    }

    return { isError: false, data: data, total: total };
  }

  onError(_msg, _target) {
    // console.log(this.name,"onError");
    $('p', this.error).html(_msg);

    let top = $('.room_ttl', _target).offset().top;
    if (!Util.isBreakpoint) { top -= this.modal.offset().top; }
    this.error.css({ top: top });

    TweenMax.killTweensOf(this.error);
    this.error.css({ display: '' });
    if (this.prevErrorPosition !== top) { TweenMax.set(this.error, { opacity: 0, y: '5%' }); }
    this.prevErrorPosition = top;
    const time = 0.3;
    const ease = Power2.easeOut;
    TweenMax.to(this.error, time, {
      opacity: 1, y: '0%', ease: ease, onComplete: () => {
        TweenMax.to(this.error, time, {
          delay: 1, y: '5%', opacity: 0, ease: ease, onComplete: () => {
            this.error.css({ display: 'none' });
          },
        });
      },
    });
  }

  onClickAddRoom(e) {
    e.preventDefault();
    if (this.rooms.length >= this.roomMax) {
      //
    } else {
      this.addRoom();
    }
  }

  addRoom() {
    let target = $(this.HTML_TEMPLATE_ROOM).appendTo(this.roomInsertTarget);
    const room = new PassengerRoomClass(target, this.rooms.length);
    room.onCreate();
    room.on(room.EVENT_DELETE, (e, p) => {
      this.isCloseBlock = true;
      this.removeRoom(p.index);
    });
    room.on(room.EVENT_ERROR, (e, p) => {
      this.onError(p.msg, p.target);
    });
    this.rooms.push(room);

    if (this.rooms.length >= this.roomMax) {
      this.btnAddRoomVisibleChange(false);
    } else {
      this.btnAddRoomVisibleChange(true);
    }
    // console.log(this.name,"addRoom",this.rooms.length);
  }

  removeRoom(_index) {
    // console.log(this.name,"removeRoom",_index,this.rooms.length);
    let dlTarget = this.rooms.splice(_index, 1);
    for (let k in dlTarget) {
      dlTarget[k].off(dlTarget[k].EVENT_DELETE);
      dlTarget[k].off(dlTarget[k].EVENT_ERROR);
      dlTarget[k] = null;
    }
    dlTarget = null;

    for (let i = 0; i < this.rooms.length; i++) {
      this.rooms[i].onChangeIndex(i);
    }
    if (this.rooms.length >= this.roomMax) {
      this.btnAddRoomVisibleChange(false);
    } else {
      this.btnAddRoomVisibleChange(true);
    }
    // console.log("removeRoom2",this.rooms.length);
  }

  btnAddRoomVisibleChange(_flag) {
    if (this.isAddBtnFlag === _flag) { return; }
    if (_flag) {
      $('.css_button', this.btnAddRoom).removeClass('disable');
    } else {
      $('.css_button', this.btnAddRoom).addClass('disable');
    }
    this.isAddBtnFlag = _flag;
  }

  resetRoom() {
    // console.log(this.name,"resetRoom",this.prevRoomsData,this.rooms);
    if (this.prevRoomsData) {
      for (let k in this.rooms) {
        this.rooms[k].off(this.rooms[k].EVENT_DELETE);
        this.rooms[k].off(this.rooms[k].EVENT_ERROR);
        this.rooms[k].target.remove();
        this.rooms[k] = null;
      }
      this.rooms = null;
      this.rooms = [];

      for (let k in this.prevRoomsData) {
        this.addRoom();
      }
      for (let i = 0; i < this.prevRoomsData.length; i++) {
        this.rooms[i].onSetData(this.prevRoomsData[i]);
      }
    }
  }

  setPassengerButtonText() {
    let adultCount = 0;
    let childCount = 0;
    const roomCount = this.rooms.length;
    for (let k in this.rooms) {
      const r = this.rooms[k];
      adultCount += Number(r.adult.n);
      childCount += Number(r.child.n);
    }
    const text = '大人' + adultCount + '名,子供' + childCount + '名,' + roomCount + '部屋';
    this.onSetClickTargetText(text);
  }

  getPassengerButtonText() {
    return $('.text', this.clickTarget).text();
  }

  /**
     * 宿泊者のエラーチェック
     * @param _data: Object
     * @returns {{msg: string, isError: boolean}}
     * @constructor
     */
  static passengersCheck(_data) {
    let isError = false;
    let msg = '';

    if (_data.length > 8) {
      msg = LtikeCommon.HOTEL.TEXT.MODAL_PASSENGER_ERROR1;
      isError = true;
    } else {
      for (let k in _data) {
        const d = _data[k];
        if (d.adult < 1) {
          isError = true;
          msg = LtikeCommon.HOTEL.TEXT.MODAL_PASSENGER_ERROR2;
          break;
        } else if (d.adult + d.child > 8) {
          isError = true;
          msg = LtikeCommon.HOTEL.TEXT.MODAL_PASSENGER_ERROR3;
        }
      }
    }
    return { isError: isError, msg: msg };
  }

}
